<template>
  <div class="row">
    <!--  用户列表  -->
    <div class="flex xs12">
      <va-card title="导师列表">
        <div class="row align--center mb-1">
          <div class="flex md12 xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">擅长领域：</va-button>
              <va-button class="mb-2" flat :color="expertFieldId ? 'gray' : 'info'" v-on:click="handleMentorExpertFieldIdChange(null)">全部标签</va-button>
              <va-button class="mb-2" flat :color="expertFieldId === val.id ? 'info' : 'gray'" v-for="val in mentorExpertFields" :key="val.id" v-on:click="handleMentorExpertFieldIdChange(val.id)"
              >{{ val.name }}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray" >活跃状态：</va-button>
              <va-button class="mb-2" flat :color="isActive ? 'info' : 'gray'" v-on:click="handleIsActiveChange(true)">活跃</va-button>
              <va-button class="mb-2" flat :color="isActive ? 'gray' : 'info'" v-on:click="handleIsActiveChange(false)">不活跃</va-button>
            </va-button-group>
            <div class="row">
              <div class="flex md6 xs12 sm6">
                <va-input
                  class="ma-0"
                  :value="nickname"
                  placeholder="搜索导师姓名"
                  @input="search"
                  removable
                >
                  <va-icon name="fa fa-search" slot="prepend"/>
                </va-input>
              </div>
              <div class="flex md6 xs12">
                <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
              </div>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="mentors"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listMentor"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              v-bind:style="{width: '50%', margin: '1rem auto'}"
              oninput="if(value<0)value=1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>

          <template slot="isActive" slot-scope="props">
            <va-badge :color=computeIsActiveColor(props.rowData.isActive).color>
              {{ computeIsActiveColor(props.rowData.isActive).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getMentor/${props.rowData.uid}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true; deleteUid=props.rowData.uid"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除导师"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import mentorApi from '../../api/mentor'
import { TAG_TYPE } from '@/utils/constants'
import tagApi from '../../api/tag'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      mentors: [],
      nickname: null,
      loading: true,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      mentorExpertFields: [],
      expertFieldId: null,
      isActive: true,
      deleteModal: false,
      deleteUid: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'nickname',
          title: '用户姓名',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:isActive',
          title: '活跃状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '申请成为导师时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listMentor()
    this.listMentorExpertField()
  },
  methods: {
    listMentor (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        nickname: this.nickname,
        expertFieldId: this.expertFieldId,
        isActive: this.isActive,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.mentors.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.loading = false
      }).catch(error => alert(error))
    },
    listMentorExpertField () {
      tagApi.listTag({ tagType: TAG_TYPE.EXPERT_FIELD_TAG.CODE }).then(response => {
        this.mentorExpertFields = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    handleMentorExpertFieldIdChange (id) {
      this.expertFieldId = id
      this.listMentor()
    },
    handleIsActiveChange (isActive) {
      this.isActive = isActive
      this.listMentor()
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') { this.nickname = null }
      this.listMentor(1)
    }, 400),
    updateSortNum: function (params) {
      if (params.sortNum === null) {
        return
      }
      const data = {
        mentorUid: params.uid,
        sortNum: params.sortNum,
      }
      mentorApi.updateMentor(params.uid, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listMentor()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computeIsActiveColor: function (isActive) {
      const data = {
        color: 'info',
        text: '活跃',
      }
      if (!isActive) {
        data.text = '不活跃'
        data.color = 'gray'
      }
      return data
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      mentorApi.deleteMentor(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除导师成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listMentor()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
